const SET_ICON_BASE = 'https://trademagic-assets.s3.us-west-1.amazonaws.com/sets/icons';

/** The set symbol SVG for a set code, or null without one. Pass to SetIcon, which hides itself on a 404. */
export const setIconUrl = (setCode: string | null | undefined): string | null =>
  setCode ? `${SET_ICON_BASE}/${setCode.toLowerCase()}.svg` : null;
